module.exports = __webpack_public_path__ + "static/img/streets-of-coverage.7d08a65.png";